var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContegrationTestOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5218 9.76758C14.9212 9.76758 14.4326 10.2562 14.4326 10.8567C14.4326 11.4573 14.9212 11.9459 15.5218 11.9459C16.1223 11.9459 16.6109 11.4573 16.6109 10.8567C16.6109 10.2562 16.1223 9.76758 15.5218 9.76758ZM15.5218 7.76758C17.2278 7.76758 18.6109 9.15064 18.6109 10.8567C18.6109 12.5628 17.2278 13.9459 15.5218 13.9459C13.8157 13.9459 12.4326 12.5628 12.4326 10.8567C12.4326 9.15064 13.8157 7.76758 15.5218 7.76758Z",
    fill: "#272D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5557 13.6465L18.9997 15.1015",
    stroke: "#272D55",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9997 15.4653H10.9999C10.7243 15.4653 10.5 15.2411 10.5 14.9654V1.71474C10.5 1.43909 10.7243 1.21484 10.9999 1.21484H12.9997C13.2754 1.21484 13.4996 1.43909 13.4996 1.71474V7.25872C12.2591 8.08983 11.4998 9.49788 11.4998 11.0009C11.4998 12.5036 12.2591 13.9113 13.4996 14.7423V14.9654C13.4996 15.2411 13.2754 15.4653 12.9997 15.4653Z",
    fill: "#272D55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9538 14.9653C11.7442 14.0333 11.0111 12.582 10.9999 11.0367L10.9999 14.9653H12.9538ZM10.9999 10.9651C11.0112 9.4 11.7627 7.93137 12.9996 7.00083L12.9997 1.71484L11 1.71474L10.9999 10.9651ZM12.9997 15.9653H10.9999C10.4486 15.9653 10 15.5168 10 14.9654V1.71474C10 1.16339 10.4486 0.714844 10.9999 0.714844H12.9997C13.5511 0.714844 13.9996 1.16339 13.9996 1.71474V7.5359C12.7659 8.24979 11.9998 9.57718 11.9998 11.0009C11.9998 12.424 12.7661 13.7514 13.9996 14.4651V14.9654C13.9996 15.5168 13.5511 15.9653 12.9997 15.9653Z",
    fill: "#272D55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.84766H1C0.447715 8.84766 0 9.29537 0 9.84766V14.9647C0 15.5169 0.447715 15.9647 1 15.9647H3C3.55228 15.9647 4 15.5169 4 14.9647V9.84766C4 9.29537 3.55228 8.84766 3 8.84766Z",
    fill: "#272D55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.34766H1C0.723858 9.34766 0.5 9.57151 0.5 9.84766V14.9647C0.5 15.2408 0.723858 15.4647 1 15.4647H3C3.27614 15.4647 3.5 15.2408 3.5 14.9647V9.84766C3.5 9.57151 3.27614 9.34766 3 9.34766Z",
    stroke: "#272D55"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.78125H6C5.44772 4.78125 5 5.22897 5 5.78125V14.9653C5 15.5175 5.44772 15.9653 6 15.9653H8C8.55228 15.9653 9 15.5175 9 14.9653V5.78125C9 5.22897 8.55228 4.78125 8 4.78125Z",
    fill: "#272D55"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.28125H6C5.72386 5.28125 5.5 5.50511 5.5 5.78125V14.9653C5.5 15.2414 5.72386 15.4653 6 15.4653H8C8.27614 15.4653 8.5 15.2414 8.5 14.9653V5.78125C8.5 5.50511 8.27614 5.28125 8 5.28125Z",
    stroke: "#272D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContegrationTestOperationIcon);
export default __webpack_public_path__ + "static/media/ContegrationTestOperationIcon.542c38cd0630862819d563a9eef9d200.svg";
export { ForwardRef as ReactComponent };